// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"BrokerShipmentDetailsSection_cardBody__2DFfA","nonFirstRowCard":"BrokerShipmentDetailsSection_nonFirstRowCard__14b3f"};